<template>
  <section class="ut-p-6 prospect-stage-question">
    <h3 class="question-title">Sorry to hear that, what went wrong?</h3>
    <div >
      <div class="ut-flex ut-flex-wrap ut-content-start">
        <radio-button v-for="btn in answers"
                  :key="btn.id"
                  :id="btn.id"
                  class="ut-w-full md:ut-w-2/5 lg:ut-w-4/12 ut-flex-shrink-0"
                  v-bind:class="`md:ut-order-${btn.order}`"
                  :name="'What was the outcome'"
                  v-gaEvent="{ category: gacategory, action: `Agent feedback negative - ${btn.label.toLowerCase()}`}"
                  v-model="selectedAnswer"
                  :selectedValue="selectedAnswer"
                  :radioValue="btn.value">
                  {{ btn.label }}</radio-button>
      </div>
      <span class="error ut-text-sm ut-font-bold"
            v-show="validationError">
            Please select an option</span>
    </div>
    <button @click="confirm()"
            class="btn btn-green-inverted confirm-btn"
            :class="{ 'disabled': disabledButtonClick }">Confirm</button>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import RadioButton from '@/components/Forms/RadioButton.vue';

export default {
  name: 'ProspectQualityQuesLowRatingReason',
  components: {
    RadioButton,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      selectedAnswer: null,
      validationError: false,
      answers: [
        {
          id: 'already-on-the-market',
          value: 1,
          order: 1,
          label: 'Already on the market',
        },
        {
          id: 'not-selling',
          value: 2,
          order: 3,
          label: 'Not selling',
        },
        {
          id: 'not-interested-in-talking',
          value: 3,
          order: 5,
          label: 'Not interested in talking',
        },
        {
          id: 'wrong-address',
          value: 4,
          order: 2,
          label: 'Wrong address',
        },
        {
          id: 'wrong-number',
          value: 5,
          order: 4,
          label: 'Wrong number',
        },
        {
          id: 'other',
          value: 6,
          order: 6,
          label: 'Other',
        },
      ],
      disabledButtonClick: false,
    };
  },
  computed: {
    ...mapState({
      rating: state => state.prospectStore.rating,
    }),
  },
  created() {},
  methods: {
    ...mapActions('prospectStore', [
      'updateContactRating',
    ]),
    confirm() {
      if (this.disabledButtonClick) {
        return false;
      }

      if (!this.selectedAnswer) {
        this.validationError = true;
        return false;
      }

      this.disabledButtonClick = true;
      this.$helpers.gaEvent(this.gacategory, 'Agent feedback negative confirm');

      const payload = {
        ...this.rating,
        ratingResponseTypeId: this.selectedAnswer,
      };

      this.updateContactRating(payload).then(() => {
        if (this.selectedAnswer === 6) {
          this.$emit('update-view', 'lowRatingReasonCustom');
        } else {
          this.$emit('update-view', 'contactedCallOutcomeAlt');
        }
      }).catch((error) => {
        this.disabledButtonClick = false;
        console.error(error);
      });

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
